import { useCallback } from 'react';
import { isBloggerBusiness } from '../../../../../utils/accessService';
import { analyticsService, EventSource } from '../../../../../utils/analyticsService';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ReviewsInfo } from '../../../ReviewsInfo/ReviewsInfo';
import { StatusBadge } from '../../../StatusBadge';
import { BusinessType } from '../../../types';
import { ProfileMenu } from '../ProfileMenu/ProfileMenu';
import { ProfileInfoProps } from './types';

export const ProfileInfo = ({
    title,
    subtitle,
    business,
    user,
    cpaButton,
    onBadgeClick,
    onReport,
    onPersistBusinessCover,
}: ProfileInfoProps) => {
    const t = useTranslation();

    const isBlogger = isBloggerBusiness(business?.type);

    let profileType = business?.type === BusinessType.BUSINESS ? t('Бизнес') : undefined;

    if (isBlogger) {
        profileType = t('Автор');
    }

    if (business?.isService) {
        profileType = t('Услуги');
    }

    const onReviewClick = useCallback(() => {
        analyticsService.trackReviewClick({
            businessId: business?.id,
            clickoutUrl: business?.reviewsInfo?.url,
            eventSource: EventSource.BUSINESS,
        });
    }, [business?.id, business?.reviewsInfo?.url]);

    return (
        <Flex direction="column" spacing={0.25}>
            <Flex direction="row" spacing={1} alignItems="center">
                <Typography variant="title2" weight="bold">
                    {title}
                </Typography>
                <ProfileMenu
                    business={business}
                    user={user}
                    onReport={onReport}
                    onPersistBusinessCover={onPersistBusinessCover}
                />
            </Flex>
            {subtitle ? (
                <Typography variant="caption" color="secondary">
                    {subtitle}
                </Typography>
            ) : null}
            {profileType || business?.reviewsInfo ? (
                <Flex direction="row" spacing={0.5} alignItems="center">
                    <Typography variant="caption" color="secondary">
                        {profileType}
                    </Typography>
                    {business?.reviewsInfo ? (
                        <ReviewsInfo {...business.reviewsInfo} onClick={onReviewClick} />
                    ) : null}
                </Flex>
            ) : null}
            {business?.status ? (
                <StatusBadge
                    mt={0.25}
                    businessStatus={business.status}
                    statusDisplay={business.statusDisplay}
                    onClick={onBadgeClick}
                />
            ) : null}
            {cpaButton}
        </Flex>
    );
};
